const domainEnvironment =
  window.location.hostname === "www.azeto.ir" ? "production" : "development";

export const azeto =
  domainEnvironment === "production"
    ? {
        Core: process.env.REACT_APP_CORE_V1_API,
        Notification: process.env.REACT_APP_NOTIFICATION_V1_API,
        Account: process.env.REACT_APP_ACCOUNT_V1_API,
        Wallet: process.env.REACT_APP_WALLET_V1_API,
        ImageUrl: process.env.REACT_APP_IMAGE_URL,
        Meili: process.env.REACT_APP_MEILI_URL,
      }
    : {
        Core: process.env.REACT_APP_CORE_V1_TEST_API,
        Notification: process.env.REACT_APP_NOTIFICATION_V1_TEST_API,
        Account: process.env.REACT_APP_ACCOUNT_V1_TEST_API,
        Wallet: process.env.REACT_APP_WALLET_V1_TEST_API,
        ImageUrl: process.env.REACT_APP_IMAGE_URL_TEST,
        Meili: process.env.REACT_APP_MEILI_URL_TEST,
      };

export const azetoV2 =
  domainEnvironment === "production"
    ? {
        Core: process.env.REACT_APP_CORE_V2_API,
        Notification: process.env.REACT_APP_NOTIFICATION_V2_API,
        Account: process.env.REACT_APP_ACCOUNT_V2_API,
        Wallet: process.env.REACT_APP_WALLET_V2_API,
      }
    : {
        Core: process.env.REACT_APP_CORE_V2_TEST_API,
        Notification: process.env.REACT_APP_NOTIFICATION_V2_TEST_API,
        Account: process.env.REACT_APP_ACCOUNT_V2_TEST_API,
        Wallet: process.env.REACT_APP_WALLET_V2_TEST_API,
      };

// https://api.azeto.ir/api/v0.1/core/
// http://api.ateto.ir/api/v0.1/core/
